import { render, staticRenderFns } from "./SanitizationQueue.vue?vue&type=template&id=240ec4c0&scoped=true&"
import script from "./SanitizationQueue.vue?vue&type=script&lang=js&"
export * from "./SanitizationQueue.vue?vue&type=script&lang=js&"
import style0 from "./SanitizationQueue.vue?vue&type=style&index=0&id=240ec4c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240ec4c0",
  null
  
)

export default component.exports